import VritraIcon from "../../../VritraIcon";
//import Preview from "./Preview/Preview";


const ActionHandlerProps=[
    {
        name:"color",
        type:"string",
        description:"the color prop value",
    },
    {
        name:"element",
        type:"ActionSetActionElement",
        description:"the action HTML element",
    },
    {
        name:"ActionSetActionElement",
        type:"HTMLButtonElement",
        props:[
            {
                name:"setIcon",
                type:"(icon:string|((color:string,weight=2)=>string)):void",
                /* description:`
                    you can just edit the img element src yourself, but this method will make sure that your code
                    keeps behaving the same way independently of package versions.
                `, */
            },
            {
                name:"setLabel",
                type:"(string):void",
            },
        ],
    }
],ActionSetDefinitionProps=[
    {
        name:"id",
        type:"string",
        required:true,
    },
    {
        name:"component",
        type:"(props:ActionSetAction&{parent:ActionSetView}:HTMLElement",
        description:"Used to add custom action component, should return an HTMLElement",
    },
    VritraIcon,
    {
        name:"label",
        type:"string",
    },
    {
        name:"iconAlt",
        type:"string",
        description:"action image element alt attribute value",
    },
    {
        name:"size",
        type:"number",
        defaultValue:6.4,
        description:"action size in em unit",
    },
    {
        name:"color",
        type:"string",
        defaultValue:"tintColor",
    },
    {
        name:"style",
        type:"CSSStyleDeclaration",
    },
    {
        name:"onReady",
        type:"(action:object):void",
        description:"Called when the action HTMLElement is ready to be triggered",
    },
    {
        name:"onTrigger",
        type:"(action:object):void",
        description:"called when action element clicked",
        props:ActionHandlerProps,
        notice:"If the action was rendered using the component prop, you need to add a click event yourself",
    },
];

export const ActionSetDefinition={
    name:"ActionSetDefinition",
    type:"object",
    props:ActionSetDefinitionProps,
}

const ActionSetAction={
    name:"ActionSetAction",
    type:"string|object",
    props:[
        {
            name:"ref",
            type:"string",
            required:true,
        },
        ...ActionSetDefinitionProps,
    ],
}

export default {
    id:"ActionSetView",
    parent:{name:"View"},
    //preview:Preview,
    description:"renders a horizontal list of actions",
    cssvars:[
        {name:"spacing",type:"5em"},
    ],
    props:[
        {
            name:"definitions",
            type:"ActionSetDefinition[]",
            props:[ActionSetDefinition],
        },
        {
            name:"actions",
            type:"ActionSetAction[]",
            props:[ActionSetAction],
        },
        {
            name:"tintColor",
            type:"string",
            description:"the value of the color param for function-icons",
        }
    ],
};
